import axios from 'axios'
import ToastComponent from 'COMPONENTS/Toast.vue'// 引入先前写好的vue
import LoadingComponent from 'COMPONENTS/Loading.vue'
import LoginComponent from 'COMPONENTS/LoginPanel.vue'
//过滤器，自定义组件，全局方法，实例方法，mixin等在这里添加
export default{
	install(Vue,router){
		// 请求拦截器
		axios.interceptors.request.use(request => {
			if(!request.url.startsWith("http")){
				request.url = API_SERVER + "/api" + request.url;
			}
			let token = localStorage.getItem("token")
            request.headers['H5TOKEN'] = token;
			request.timeout = 120000;
			return request
		});
		// 返回拦截器
		axios.interceptors.response.use(response => {
			if (response.status === 401) {
				// router.push("/login")
				// Vue.prototype.$showLogin()
			}
			return response.data
			// return Promise.reject(response);
		}, error => {
			if (error.response&&error.response.status === 401) {
				// router.push("/login")
				// Vue.prototype.$showLogin()
			}
			return Promise.reject(error);
		});
		Vue.prototype.$http = axios;
		//loading插件
        const LoadingConstructor = Vue.extend(LoadingComponent);
        const LoadingInstance = new LoadingConstructor({
            el:document.createElement("div")
        });
        document.body.appendChild(LoadingInstance.$el);
        Vue.prototype.$loading = {
            show(){
                LoadingInstance.loadingShow = true;
            },
            hide(){
                LoadingInstance.loadingShow = false;
            }
        }
		//toast插件
		const ToastConstructor = Vue.extend(ToastComponent);
		Vue.prototype.$toast = (msg, duration = 1250) => {
			const ToastInstance = new ToastConstructor({
				el:document.createElement("div")
			});
            document.body.appendChild(ToastInstance.$el);
            ToastInstance.msg = msg;
            ToastInstance.theToast = true;
     
            let timer = setTimeout(() => {
				clearTimeout(timer)
				let timer2 = setTimeout(()=>{
					clearTimeout(timer2)
					document.body.removeChild(ToastInstance.$el);
				},400)
                ToastInstance.theToast = false;
            }, duration);
        }
		//登录插件
        const LoginConstructor = Vue.extend(LoginComponent);
		const LoginInstance = new LoginConstructor({
			el:document.createElement("div")
		});
		document.body.appendChild(LoginInstance.$el);
		Vue.prototype.$showLogin = ()=>{
			LoginInstance.show();
		}
		Vue.prototype.$hideLogin = ()=>{
			LoginInstance.coverVisible = false;
		}
		// 获取用户信息
		Vue.prototype.$fetchUserProfile = function() {
			return axios.get('/front/user/profile/').then(res => {
				console.log(res.data)
				if (res && res.data) {
					this.$store.commit('setUser', res.data);
				} else {
					localStorage.removeItem('token');
					this.$store.commit('clearUser');
					this.$toast('登录已失效，请重新登录');
				}
			}).catch(() => {
				localStorage.removeItem('token');
				this.$store.commit('clearUser');
				this.$toast('登录已失效，请重新登录');
			});
		}
		// 退出登录
		Vue.prototype.$logout = function() {
			localStorage.removeItem('token');
			this.$store.commit('clearUser');
			this.$toast('已退出登录');
			window.location.reload();
		}
		//自定义指令
		// Vue.directive('my-directive', {
		// 	bind (el, binding, vnode, oldVnode) {
		// 	  // 逻辑...
		// 	}
		// })
		
		// 注入组件选项
		// Vue.mixin({
		// 	created: function () {
		// 		// 逻辑...
		// 	}
		// })

		//自定义过滤器
		Vue.filter('formatTime', function (value) {
			//13位时间戳
			Date.prototype.Format = function (fmt) { //author: meizz
			  var o = {
				"M+": this.getMonth() + 1, //月份
				"d+": this.getDate(), //日
				"h+": this.getHours(), //小时
				"m+": this.getMinutes(), //分
				"s+": this.getSeconds(), //秒
				"q+": Math.floor((this.getMonth() + 3) / 3), //季度
				"S": this.getMilliseconds() //毫秒
			  };
			  if (/(y+)/.test(fmt))
				fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
			  for (var k in o)
				if (new RegExp("(" + k + ")").test(fmt))
				  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			  return fmt;
			}
			return new Date(value).Format("yyyy-MM-dd hh:mm:ss");
		  })

		// 全局socket链接
		Vue.prototype.$sockets = function (namespace) {
			let token = localStorage.getItem('token');
			let socketUrl = namespace ? `${API_SERVER}/${namespace}?token=${token}` : `${API_SERVER}?token=${token}`;
			if (namespace.indexOf("?") > 1) {
				socketUrl = `${API_SERVER}/${namespace}&token=${token}`;
			}
			return io.connect(socketUrl)
		};

		//下载Excel文件
        Vue.prototype.downloadExcel = function (url, name) {
			return new Promise((resolve, reject) => {
				axios({
					url: url,
					method: 'GET',
					responseType: 'blob', // important
				}).then((resp) => {
					let blob = new Blob([resp], { type: 'application/octet-stream' });
					let url = window.URL.createObjectURL(blob);
					let link = document.createElement("a");
					link.style.display = "none";
					link.href = url;
					link.setAttribute("download", name);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url)
					resolve(resp)
				}).catch(function (error) {
					console.log(error)
					reject(error)
				});

			})
        };
	}
}